
    (function(){
      const root      = document.getElementById('sc-template--19513287016490__highlight_carousel_colordown_mWAE8G');
      const viewport  = root.querySelector('.sc-viewport');
      const panelsEl  = root.querySelector('.sc-panels');
      const panels    = Array.from(root.querySelectorAll('.sc-panel'));
      const radios    = Array.from(root.querySelectorAll('input[name="slide-template--19513287016490__highlight_carousel_colordown_mWAE8G"]'));
      const nextBtn   = root.querySelector('.sc-next');
      const autoplayMs= 4000;
      const autoplay  = true;
      const single    = 2 <= 1;
      const isTwo     = 2 === 2;
    
      let timer, visible = false, didDrag = false;
    
      panelsEl.addEventListener('dragstart', e => e.preventDefault());
      root.querySelectorAll('img, picture, source').forEach(el => el.setAttribute('draggable','false'));
    
      const isDesktop = () => window.matchMedia('(min-width: 769px)').matches;
      const twoDesktop = () => isTwo && isDesktop();
    
      const idx    = () => radios.findIndex(r => r.checked);
      const gap    = () => parseFloat(getComputedStyle(panelsEl).gap || '0') || 0;
      const panelW = () => (panels[0]?.clientWidth || viewport.clientWidth);
      const stepW  = () => panelW() + gap();
    
      const baseX  = () => -(idx() * stepW());
      const setX   = (x = baseX()) => panelsEl.style.transform = `translateX(${x}px)`;
    
      function markActive(i){ panels.forEach((p,n)=>p.classList.toggle('sc-active', n===i)); }
    
      function goTo(i){
        if (!radios.length) return;
        if (twoDesktop()) { i = 0; }
        else { i = (i + radios.length) % radios.length; }
        radios[i].checked = true;
        setX(); markActive(i);
      }
      const next = () => goTo(idx()+1);
      const prev = () => goTo(idx()-1);
    
      function stopAutoplay(addPausedClass = true){
        clearInterval(timer);
        if (addPausedClass) root.classList.add('sc-paused');
      }
      function startAutoplay(){
        stopAutoplay(false);
        if (!autoplay || !visible || single || twoDesktop()) { root.classList.add('sc-paused'); return; }
        root.classList.remove('sc-paused');
        timer = setInterval(next, autoplayMs);
      }
      function maybeStartAutoplay(){
        if (autoplay && visible && !single && !twoDesktop()) startAutoplay(); else stopAutoplay(true);
      }
    
      const io = new IntersectionObserver((entries)=>{
        entries.forEach(entry=>{
          visible = entry.isIntersecting && entry.intersectionRatio >= 0.6;
          maybeStartAutoplay();
        });
      }, { threshold: [0, 0.25, 0.6, 1] });
      io.observe(root);
    
      window.addEventListener('load', ()=>{ setX(); markActive(0); maybeStartAutoplay(); });
      window.addEventListener('resize', ()=>{ clearTimeout(root.__rsz); root.__rsz=setTimeout(()=>{ setX(); maybeStartAutoplay(); },100); });
    
      radios.forEach((r,i)=> r.addEventListener('change', ()=>{ if (twoDesktop()) { goTo(0); return; } goTo(i); maybeStartAutoplay(); }));
      if (nextBtn) nextBtn.addEventListener('click', ()=>{ if (twoDesktop()) { goTo(0); return; } next(); maybeStartAutoplay(); });
    
      if (!single){
        let dragging=false, startX=0, startY=0, startT=0, lock=null, startOffset=0;
        function onDown(e){
          if (twoDesktop()) return;
          if (e.buttons !== undefined && e.buttons !== 1 && e.pointerType === 'mouse') return;
          dragging=true; lock=null; didDrag=false;
          startX=e.clientX; startY=e.clientY; startT=performance.now();
          startOffset=baseX();
          panelsEl.classList.add('sc-dragging'); viewport.classList.add('is-dragging'); stopAutoplay();
          panelsEl.setPointerCapture?.(e.pointerId);
        }
        function onMove(e){
          if (!dragging) return;
          const dx=e.clientX-startX, dy=e.clientY-startY;
          if (lock==null && (Math.abs(dx)>8 || Math.abs(dy)>8)) lock = Math.abs(dx)>=Math.abs(dy)?'x':'y';
          if (lock==='y'){ onUp(e,true); return; }
          if (lock==='x'){ panelsEl.style.transform = `translateX(${startOffset + dx}px)`; e.preventDefault?.(); if (Math.abs(dx) > 6) didDrag = true; }
        }
        function onUp(e, cancel=false){
          if (!dragging) return;
          dragging=false; panelsEl.classList.remove('sc-dragging'); viewport.classList.remove('is-dragging'); panelsEl.releasePointerCapture?.(e.pointerId);
          if (cancel){ setX(); maybeStartAutoplay(); return; }
          const dx=e.clientX-startX, dt=Math.max(1, performance.now()-startT), vx=dx/dt;
          const threshold = Math.max(40, stepW()*0.15), speed=0.35;
          if (dx<=-threshold || vx<=-speed) next(); else if (dx>=threshold || vx>=speed) prev(); else setX();
          maybeStartAutoplay();
          if (didDrag){ setTimeout(()=>{ didDrag=false; }, 0); }
        }
        viewport.addEventListener('pointerdown', onDown, {passive:true});
        window.addEventListener('pointermove', onMove, {passive:false});
        window.addEventListener('pointerup', onUp, {passive:true});
        window.addEventListener('pointercancel', e=>onUp(e,true), {passive:true});
        root.addEventListener('click', (e)=>{ if (didDrag){ e.preventDefault(); e.stopPropagation(); } }, true);
      } else {
        setX(0); stopAutoplay(true);
      }
    })();
  
